import { useEffect } from "react";

/**
 * Inject a JSON-LD script tag into <head>. Removes it on unmount.
 * Accepts any valid schema.org JSON object.
 */
export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let tag = document.getElementById(scriptId);
    const created = !tag;
    if (!tag) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = scriptId;
      document.head.appendChild(tag);
    }
    const prev = tag.textContent;
    tag.textContent = JSON.stringify(data);
    return () => {
      if (created) {
        tag.remove();
      } else if (prev != null) {
        tag.textContent = prev;
      }
    };
  }, [id, data]);
}

/** Canonical Person schema for JJ — reused on Home + Recruiter. */
export const PERSON_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "JJ Argent",
  alternateName: "JJ Argent",
  url: "https://jjargent.com/",
  image: "https://jjargent.com/og-image.jpg",
  jobTitle: "Senior Program, Events & Operations Leader",
  description:
    "Senior programs, events and operations leader. 13+ years across universities and major events in Australia and Canada. Available for senior roles.",
  email: "mailto:contact@jjargent.com",
  sameAs: ["https://www.linkedin.com/in/jesse-argent-771472171"],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Melbourne",
    addressCountry: "AU",
  },
  worksFor: {
    "@type": "Organization",
    name: "Independent · Available for senior roles",
  },
  knowsAbout: [
    "University Operations",
    "Program Design",
    "Major Events",
    "Student Experience",
    "Operational Systems",
    "AI-Enabled Workflows",
    "Accessibility",
  ],
  nationality: { "@type": "Country", name: "Australia" },
};
